import { Button, ButtonType } from '@yy/tofu-ui-react';
import axios from 'axios';
import React, { useContext } from 'react';
import App, { AnchorSignContext, UserRoleContext } from '../App';
import { SignStatus } from '../models/AnchorSignStatus';
import { HTTPService, isAnchor, UserRole, hiddoClick } from '../util';

const MoreInfoContent: React.FC<{
  showDialog: () => void;
  showErrorDialog: (msg: string) => void;
  showChatWarnDialog: () => void;
  guildYY: string;
  guildUid: string;
}> = ({
  showDialog,
  guildYY,
  guildUid,
  showErrorDialog,
  showChatWarnDialog
}) => {
  const userRole = useContext(UserRoleContext);
  const anchorSignInfo = useContext(AnchorSignContext);

  // console.log('blah', anchorSignInfo);
  // console.log('blah guildYY', guildYY);
  // console.log('blah guildUid', guildUid);

  const appliedInfo =
    anchorSignInfo.applyList && anchorSignInfo.applyList[guildUid];
  const invitedInfo =
    anchorSignInfo.inviteList && anchorSignInfo.inviteList[guildUid];

  const onAdvisoryClick = async () => {
    hiddoClick('12');

    if (!App.isLoggedIn()) {
      window.user?.showYYLoginBox();
      return;
    }
    const { data: roleData } = await axios.get(
      '//www.yy.com/zone/microservice/guildserver/guildInfo/getGuildType',
      {
        params: { yyNo: guildYY }
      }
    );

    if (+roleData.code === 0) {
      if (roleData.data < 1) {
        showChatWarnDialog();
        return false;
      }
    }

    const {
      data
    } = await axios.get(
      '//www.yy.com/zone/microservice/guildserver/guild/chatLink',
      { params: { guildYY } }
    );

    if (data.code === HTTPService.Ok) {
      const iframe = document.createElement('iframe');
      iframe.src = data.data;
      iframe.setAttribute('style', 'height:1px;width:1px;opacity:0');
      document.body.appendChild(iframe);
      // this.$toast({ msg: '已成功启动YY客服对话框，请点击允许确认本次对话（请提前登录PCYY客户端~）' });
      setTimeout(() => {
        if (iframe) {
          document.getElementsByTagName('body')[0].removeChild(iframe);
        }
      }, 10000);
    } else {
      showErrorDialog(data.msg || '调起对话框失败，请稍候重试');
    }
  };

  const onApplyClick = () => {
    hiddoClick('13');

    if (!App.isLoggedIn()) {
      window.user && window.user.showYYLoginBox();
      return;
    }

    if (userRole === UserRole.NormalUser) {
      showDialog();
      return;
    }

    window.open(`//www.yy.com/i/contract/recommend?yyNum=${guildYY}`, '_blank');
  };

  function goToSignManage() {
    window.open('//www.yy.com/i/contract/detail', '_blank');
  }

  function goToApplyOrInvitePage() {
    const info = appliedInfo || invitedInfo;
    if (info) {
      window.open(
        `${window.location.protocol}//www.yy.com/i/contract/detail?id=${info.in_id}&iType=${info.in_type}&sType=${info.in_sender_type}`,
        '_blank'
      );
    }
  }

  return (
    <div>
      <Button style={{ marginRight: 15 }} onClick={onAdvisoryClick}>
        应聘咨询
      </Button>

      {/*只有主播和普通用户两种，公会无此入口*/}
      {isAnchor(userRole) ? (
        (() => {
          switch (anchorSignInfo.code) {
            // 未签约，并没有签约邀请和签约申请
            case SignStatus.None:
              return (
                <Button type={ButtonType.Emphasis} onClick={onApplyClick}>
                  签约申请
                </Button>
              );
            // 有申请或者被邀记录
            case SignStatus.InvitedOrApplied:
              // 检查是否有申请信息
              if (appliedInfo) {
                return (
                  <Button
                    type={ButtonType.Emphasis}
                    onClick={goToApplyOrInvitePage}
                  >
                    等待公会审核
                  </Button>
                );
                // 检查是否有邀请信息
              } else if (invitedInfo) {
                return (
                  <Button
                    type={ButtonType.Emphasis}
                    onClick={goToApplyOrInvitePage}
                  >
                    查看公会邀请
                  </Button>
                );
              } else {
                // 否则，对当前公会没有申请或者被邀记录, 允许申请
                return (
                  <Button type={ButtonType.Emphasis} onClick={onApplyClick}>
                    签约申请
                  </Button>
                );
              }
            // 已签约
            case SignStatus.Signed:
              return anchorSignInfo.contract === guildUid ? (
                // 已和当前公会签约
                <Button type={ButtonType.Emphasis} onClick={goToSignManage}>
                  已签约
                </Button>
              ) : (
                // 否则，不拦截发起申请
                <Button type={ButtonType.Emphasis} onClick={onApplyClick}>
                  签约申请
                </Button>
              );
            default:
              return null;
          }
        })()
      ) : (
        <Button type={ButtonType.Emphasis} onClick={onApplyClick}>
          签约申请
        </Button>
      )}
    </div>
  );
};

export default MoreInfoContent;
